import {
  API_URL
} from '../constants'

export const V1_URL = `${API_URL}/v1/ingredients`

export const V1_ALL = `${V1_URL}/all`

export const V1_HAVE_RECIPE = `${V1_URL}/have_recipe`



// WEBPACK FOOTER //
// ./app/api/ingredients/constants.js